import { typeMetaEnum, EnumMetaType } from "@/autogen/common";
import { USStateCode } from "./USStateCode";

export type USStateCodeMetaI = EnumMetaType<typeof USStateCode, USStateCode>;
export const USStateCodeMeta = typeMetaEnum<typeof USStateCode, USStateCode>("USStateCode", USStateCode);

